module.exports = __webpack_public_path__ + "img/kor.60fde7fc.svg";